export const CATEGORIES = ['AI', 'Meme', 'Abstract Art', 'Gaming', 'Advertising'];
export const NFT_NAME = 'CryptoVerse-AI';
export const NFT_SYMBOL = 'CVS';
